import { Typography } from 'antd';
import s from './index.module.css';

const { Title } = Typography;

const BaseTitle = ({ title, subtitle, className = '' }) => {
  return (
    <div className={`${s.baseTitleHeader} ${className}`}>
      <Title level={3} className={s.baseTitle}>
        {/* <span className={s.titleDecoration}>&gt;=</span> */}
        <span className={s.titleText}>{title}</span>
        {/* <span className={s.titleDecoration}>&lt;=</span> */}
      </Title>
      {subtitle && (
        <p className={s.baseSubtitle}>{subtitle}</p>
      )}
    </div>
  );
};

export default BaseTitle;
